@let isCollapsedValue = isCollapsed();
@let isDisabledValue = disabled();

<div class="toggle-panel" [class.toggle-panel--disabled]="isDisabledValue" [attr.aria-disabled]="isDisabledValue">
  <div class="toggle-panel__toggle" (click)="togglePanel()">
    <i aria-hidden="true" [class]="'toggle-panel__icon ' + iconClass()"></i>
    <span class="toggle-panel__label">{{ label() }}</span>
    <i class="toggle-panel__chevron fa-regular fa-chevron-down" [class.toggle-panel__chevron--expanded]="!isCollapsedValue"></i>
  </div>

  <div
    class="toggle-panel__content-wrapper"
    [class.toggle-panel__content-wrapper--collapsed]="isCollapsedValue"
    [class.toggle-panel__content-wrapper--animated]="isAnimationReady()"
  >
    <div class="toggle-panel__content">
      <ng-content />
    </div>
  </div>
</div>
